import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State, FilterBy, SortBy } from './types';

export const getInitialState = () => ({
  seriesList: {},
  filterBy: FilterBy.AllSeries,
  sortBy: SortBy.NewEventDateDescending,
  currentPage: 1,
  seriesPerPage: 25,
  seriesCount: 0,
  isUpdateEventLoading: false,
  searchTerm: '',
  selectedTagIds: []
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
